module.exports = __webpack_public_path__ + "img/zoom-in.3e98caef.svg";